import React, { useState } from 'react'
import { useText } from '../../context/TextContext'
import { useOrganization } from '../../context/OrganizationContext';
import { createCustomerFormLink } from '../../utils/shared/links';
import { toast } from 'react-toastify';
import { FormControl, FormSelect, InputGroup } from 'react-bootstrap';
import { AdvancedButton } from '../AdvancedButton';
import { Organization } from '../../models/shared/Organization';
import { getBrowserLanguage, LANGUAGE_OPTIONS } from '../../utils/presentation';

export default function CustomerFormTab() {
    const text = useText();
    const { orgId, organization: organizationInDatabase, updateOrganization } = useOrganization();
    const [organization, setOrganization] = useState<Organization>(organizationInDatabase);
    const [processing, setProcessing] = useState(false);

    const formLink = createCustomerFormLink(orgId);

    const handleSave = async () => {
        setProcessing(true);
        try {
            await updateOrganization({ settings: organization.settings || {} });
            toast.success(text.defaultSuccess);
        } catch (error) {
            console.error(error);
            toast.error(text.defaultError);
        }
        setProcessing(false);
    };

    return (
        <div className='d-flex flex-column gap-3'>
            <p className='text-muted'>{text.customerFormDescription}</p>

            <div className="alert alert-info" role="alert">
                <i className="bi bi-info-circle me-2"></i>
                {text.customerFormHint}
            </div>

            <InputGroup className="mb-3">
                <FormControl
                    value={formLink}
                    readOnly
                />
                <AdvancedButton
                    icon='bi-clipboard'
                    variant="outline-secondary"
                    onClick={() => {
                        navigator.clipboard.writeText(formLink);
                        toast.success(text.linkCoppied);
                    }}
                />
            </InputGroup>

            <div>
                <label>{text.customerFormLanguage}</label>
                <p className='text-muted small m-0'>{text.customerFormLanguageDescription}</p>
                <FormSelect
                    value={organization.settings?.language || getBrowserLanguage()}
                    className='w-unset'
                    onChange={(e: any) => setOrganization({
                        ...organization,
                        settings: { ...organization.settings, language: e.target.value }
                    })}
                >
                    {LANGUAGE_OPTIONS.map((option, index) => (
                        <option key={index} value={option.value}>{option.label}</option>
                    ))}
                </FormSelect>
            </div>

            <div>
                <label>{text.customerFormIntroLabel}</label>
                <p className='text-muted small m-0'>{text.customerFormIntroDescription}</p>
                <FormControl
                    value={organization.settings?.customerFormIntroText || ''}
                    placeholder={text.tellUseAboutYourProject}
                    onChange={(e) => setOrganization({
                        ...organization,
                        settings: { ...organization.settings, customerFormIntroText: e.target.value }
                    })}
                />
            </div>

            <div>
                <label>{text.customerFormThankYouLabel}</label>
                <p className='text-muted small m-0'>{text.customerFormThankYouDescription}</p>
                <FormControl
                    as='textarea'
                    rows={2}
                    value={organization.settings?.customerFormThankYouText || ''}
                    placeholder={text.treeServiceThankYou}
                    onChange={(e) => setOrganization({
                        ...organization,
                        settings: { ...organization.settings, customerFormThankYouText: e.target.value }
                    })}
                />
            </div>

            <div className='d-flex justify-content-end'>
                <AdvancedButton icon="bi-floppy" processing={processing} onClick={handleSave}>
                    {text.save}
                </AdvancedButton>
            </div>
        </div>
    )
}